import {AbstractModel} from '../../abstract-model';
import {Site} from '../../site/site';
import {User} from '../../user';
import {Scope} from '../../../constants/scope';
import {TranslationDomain} from '../../translation/translation-domain';

export class AbstractWidget extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  type: string | null = null;
  typeName: string | null = null;
  typeDescription: string | null = null;
  site: Site | null = null;
  theme: any | null = null;
  enabled: boolean = true;
  options: any = {};
  user: User | null = null;
  private: boolean = true;
  scope: Scope = Scope.PUBLIC;
  productPriority: string | null = null;
  createdAt: Date | null = null;
  updatedAt: Date | null = null;
  transDefaultDomain: TranslationDomain | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.site) {
      this.site = new Site().deserialize(input.site);
    }

    if (input.user) {
      this.user = new User().deserialize(input.user);
    }

    if (input.transDefaultDomain) {
      this.transDefaultDomain = new TranslationDomain().deserialize(input.transDefaultDomain);
    }

    // Add extra data to options
    for (const parameter in input) {
      if (!this.hasOwnProperty(parameter)) {
        this.options[parameter] = input[parameter];
      }
    }

    return this;
  }
}
